import React from 'react';

const usePromise = (onResolve: TAnyFunction, onReject: TAnyFunction) => {
  const resolveRef = React.useRef<TAnyFunction>(() => {});
  const rejectRef = React.useRef<TAnyFunction>(() => {});

  const onResolveRef = React.useRef(onResolve);
  const onRejectRef = React.useRef(onReject);

  React.useEffect(() => {
    onResolveRef.current = onResolve;
  }, [onResolve]);

  React.useEffect(() => {
    onRejectRef.current = onReject;
  }, [onReject]);

  const init = React.useCallback(() => {
    new Promise((resolve, reject) => {
      resolveRef.current = resolve;
      rejectRef.current = reject;
    })
      .then((argument) => onResolveRef.current(argument))
      .catch(() => onRejectRef.current());
  }, []);

  React.useEffect(() => {
    init();
  }, []);

  const handleResolve = React.useCallback<TAnyFunction>((argument) => {
    resolveRef.current(argument);
  }, []);

  const handleReject = React.useCallback(() => {
    rejectRef.current();
  }, []);

  return {resolve: handleResolve, reject: handleReject, reset: init};
};

export {usePromise};
